import { Box, IconButton } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorPalette, colorTokens } from '../../../shared/components/variables';

export const AlertsHeading = styled(Box)<{ $isCarePartnerRide?: boolean }>`
  display: flex;
  position: relative;
  justify-content: space-between;
  z-index: 10;
  padding: 12px 20px;
  background-color: ${(props) => (props.$isCarePartnerRide ? colorPalette.plum200 : colorTokens.primary.dark)};
  width: 100%;
  height: 56px;

  svg {
    color: ${colorTokens.text.contrast};
    width: 1rem;
    height: 1rem;
  }
`;

export const Heading = styled(Box)<{ $isCarePartnerRide?: boolean }>`
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 12px;
  padding: 8px 20px 20px 20px;
  z-index: 10;
  background-color: ${(props) => (props.$isCarePartnerRide ? colorTokens.plum.dark : colorTokens.primary.main)};
  width: 100%;
  min-height: 132px;

  .MuiTypography-root {
    color: ${colorTokens.text.contrast};
  }
`;

export const RideInfo = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 18px;
  flex-wrap: wrap;
`;

export const MapIconButton = styled(IconButton)`
  height: 42px;
  border-radius: 12px;
  background: ${colorTokens.tonal.light};
  color: ${colorTokens.primary.main};
  opacity: 0.9;
  border: 1px solid ${colorTokens.primary.borderDark};

  &:hover {
    background: ${colorTokens.tonal.contrast};
  }
  &:focus {
    border: 2px solid ${colorTokens.secondary.main};
  }
  &:active {
    background: ${colorPalette.blue975};
    color: ${colorTokens.text.primary};
  }
`;

export const ButtonsContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-left: auto;

  .MuiButton-root {
    width: 150px;
  }

  @media (max-width: 582px) {
    .MuiButton-root {
      width: 43vw;
    }
  }
`;
